import React from "react";
import { MarkdownPage } from "./MarkdownPage";

export const HandelsappPage = () => (
  <MarkdownPage file="Handelsapp.md" />
);
